/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable no-else-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/prefer-promise-reject-errors */
import Swal from "sweetalert2";
import http from "./http-client";
import { appLogout } from "store/auth-context";

const API_URL: any = process.env.REACT_APP_API_URL;
async function client(
  endpoint: string,
  {
    data,
    headers: customHeaders,
    ...customConfig
  }: RequestInit & { data?: any; successMessage?: string } = {}
) {
  const config = {};
  const onSuccess = async (response: any) => {
    if (response.status === 200) {
      if (
        customConfig?.successMessage &&
        response?.data &&
        typeof response?.data === "string"
      ) {
        Swal.fire({
          icon: "warning",
          title: `<span style="font-size:1.5rem">Following request(s) failed.</span>`,
          html: `<ul style="text-align: left; list-style:auto; padding: 0 0 0 1.6em"><li>${response?.data?.replaceAll(",", "</li><li>")}</li></ul>`,
        });
      } else if (customConfig?.successMessage) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: customConfig?.successMessage,
        });
      }
      return response?.data;
    } else {
      return Promise.reject({ message: data?.message || response?.title });
    }
  };

  const onFail = (error: any) => {
    if (error.status === 401) {
      appLogout();

      return Promise.reject({ message: "Please re-authenticate." });
    }

    if (error.status === 409) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "The resource you are trying to add is already exist.",
      });
      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status,
      });
    }

    if (error.status === 403) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "You are not authorized to access this resource either due to access level or expired password, kindly contact support.",
      });
      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status,
      });
    }

    if (error.status === 404) {
      return Promise.reject({
        message: data?.message || error?.message || error?.title,
        status: error.status,
      });
    }

    if (error.status === 400) {
      // console.log("error", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data || error?.message || error?.title,
      });
      return Promise.reject({
        message: error?.response?.data || error?.message || error?.title,
        status: error.status,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong please try again.",
      });
      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status,
      });
    }
  };

  if (customConfig.method === "delete") {
    return http
      .delete(`${API_URL}/${endpoint}`, data)
      .then(onSuccess)
      .catch(onFail);
  } else if (data) {
    return http
      .post(`${API_URL}/${endpoint}`, data)
      .then(onSuccess)
      .catch(onFail);
  } else {
    return http
      .get(`${API_URL}/${endpoint}`, config || {})
      .then(onSuccess)
      .catch(onFail);
  }
}

export { client };
